<template>
  <div v-if="!hasDatosFiscales" class="card-resumen my-4">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col">
          <span class="title fs-m-14 text-primary">
            {{ $t('reserva.checkIn.datosFiscales') }}
          </span>
        </div>
      </div>

      <FormularioDatosFiscales ref="formularioRef" :checkins="checkins" />
    </div>
  </div>

  <div v-else class="card-resumen my-4">
    <div class="card-body">
      <div class="row">
        <div class="col text-primary">
          <span class="title fs-m-14 text-primary">
            {{ $t('reserva.checkIn.datosFiscales') }}
          </span>
          <div v-if="selectedDatosFiscales" class="datos-fiscales-preview mt-2">
            <div
              v-if="selectedDatosFiscales.tipo === TIPO_DATOS_FISCALES.PARTICULAR"
              class="fs-16 fw-medium text-primary mb-10">
              {{ selectedDatosFiscales.nombre }} {{ selectedDatosFiscales.apellidos }}
            </div>
            <div v-else class="fs-16 fw-medium text-primary mb-10">
              {{ selectedDatosFiscales.razonSocial }}
            </div>
            <div class="d-flex align-items-center datos-fiscales-container">
              <div v-if="selectedDatosFiscales.email || selectedDatosFiscales.idFiscal" class="check-container">
                <i class="fa-solid fa-circle-check text-secondary"></i>
              </div>
              <div class="datos-container">
                <div v-if="selectedDatosFiscales.telefono" class="fs-16 mb-10">
                  {{ $t('reserva.datosFiscales.telefono') }}: {{ selectedDatosFiscales.telefono }}
                </div>
                <div v-if="selectedDatosFiscales.email" class="fs-16 mb-10">
                  {{ $t('reserva.datosFiscales.email') }}: {{ selectedDatosFiscales.email }}
                </div>
                <div v-if="selectedDatosFiscales.idFiscal" class="fs-16 mb-10">
                  {{ $t('reserva.datosFiscales.nif') }}: {{ selectedDatosFiscales.idFiscal }}
                </div>
                <div v-if="selectedDatosFiscales.direccion" class="fs-16 mb-10">
                  {{ selectedDatosFiscales.direccion
                  }}{{ selectedDatosFiscales.codigoPostal ? ', ' + selectedDatosFiscales.codigoPostal : ''
                  }}{{ selectedDatosFiscales.poblacion ? ' ' + selectedDatosFiscales.poblacion : '' }}
                </div>
                <div v-if="selectedDatosFiscales.provincia" class="fs-16 mb-10">
                  {{ $t('reserva.datosFiscales.provincia') }}: {{ selectedDatosFiscales.provincia }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-auto">
          <button class="text-primary fs-13 fw-semibold btn-cambiar" @click="openModalSeleccion">
            {{ $t('botones.cambiar') }}
            <CustomIcon :icon="editIcon" size="12px" class="ms-1" />
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL SELECCIONAR DATOS FISCALES -->
  <ModalBase
    :show="showModalFormulario"
    :title="$t('reserva.datosFiscales.anadirNuevosDatos')"
    :hide-cancel="true"
    :hide-submit="true"
    @on-close="closeModalFormulario">
    <template #body>
      <FormularioDatosFiscales
        ref="formularioRef"
        :checkins="isEditMode ? [] : checkins"
        :datos-fiscales="datosFiscalesEdit"
        :is-edit-mode="isEditMode" />
    </template>
    <template #footer>
      <button class="btn btn-primary" @click="handleSubmitFormulario">
        {{ $t('botones.guardar') }}
      </button>
    </template>
  </ModalBase>

  <!-- MODAL CREAR/EDITAR DATOS FISCALES -->
  <ModalBase
    :show="showModalSeleccion"
    :title="$t('reserva.checkIn.datosFiscales')"
    :hide-cancel="false"
    :submit-text="$t('botones.guardar')"
    :cancel-text="$t('botones.cancelar')"
    :min-width="'600px'"
    @on-close="closeModalSeleccion"
    @on-submit="handleGuardarSeleccion">
    <template #body>
      <div v-if="datosFiscales.length > 0" class="mb-4">
        <div v-for="(datosFiscal, index) in datosFiscales" :key="index" class="datos-fiscales-item-modal mb-3">
          <button class="btn-edit-modal text-primary" @click.stop="openModalFormulario(datosFiscal)">
            <CustomIcon :icon="editIcon" size="16px" />
          </button>
          <div class="d-flex align-items-center datos-fiscales-container-modal text-primary">
            <div class="check-container-modal" @click="selectDatosFiscales(index)">
              <i
                v-if="tempSelectedDatosFiscalesId === datosFiscal.id"
                class="fa-solid fa-circle-check text-secondary"></i>
              <i v-else class="fa-regular fa-circle text-primary"></i>
            </div>
            <div class="datos-container-modal flex-grow-1 text-primary" @click="selectDatosFiscales(index)">
              <div
                v-if="datosFiscal.tipo === TIPO_DATOS_FISCALES.PARTICULAR"
                class="fs-16 fw-medium text-primary mb-10">
                {{ datosFiscal.nombre }} {{ datosFiscal.apellidos }}
              </div>
              <div v-else class="fs-16 fw-medium text-primary mb-10">
                {{ datosFiscal.razonSocial }}
              </div>
              <div v-if="datosFiscal.telefono" class="fs-16 text-primary mb-10">
                {{ $t('reserva.datosFiscales.telefono') }}: {{ datosFiscal.telefono }}
              </div>
              <div v-if="datosFiscal.email" class="fs-16 text-primary mb-10">
                {{ $t('reserva.datosFiscales.email') }}: {{ datosFiscal.email }}
              </div>
              <div v-if="datosFiscal.idFiscal" class="fs-16 text-primary mb-10">
                {{ $t('reserva.datosFiscales.nif') }}: {{ datosFiscal.idFiscal }}
              </div>
              <div v-if="datosFiscal.direccion" class="fs-16 text-primary mb-10">
                {{ datosFiscal.direccion }}{{ datosFiscal.codigoPostal ? ', ' + datosFiscal.codigoPostal : ''
                }}{{ datosFiscal.poblacion ? ' ' + datosFiscal.poblacion : '' }}
              </div>
              <div v-if="datosFiscal.provincia" class="fs-16 text-primary mb-10">
                {{ $t('reserva.datosFiscales.provincia') }}: {{ datosFiscal.provincia }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <button class="btn-nuevo-formulario fs-16 fw-medium ml-10" @click="openModalFormulario()">
        <span class="mr-10">+</span>
        {{ $t('reserva.checkIn.datosFiscales') }}
      </button>
    </template>
  </ModalBase>
</template>

<script setup>
  import { computed, onBeforeMount, ref } from 'vue';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import UsuarioApiService from '@/services/api/skiandnight/UsuarioApiService';
  import { useI18n } from 'vue-i18n';
  import { createToaster } from '@meforma/vue-toaster';
  import { TIPO_DATOS_FISCALES } from '@/constants/datosFiscalesConstants';
  import FormularioDatosFiscales from './FormularioDatosFiscales.vue';
  import ModalBase from '@/components/modales/ModalBase.vue';
  import CustomIcon from '@/components/CustomIcon.vue';
  import editIcon from '@/assets/icons/edit.svg';

  const props = defineProps({
    formularios: {
      type: Array,
      default: () => [],
      required: false,
    },
  });

  const emit = defineEmits(['datos-fiscales-selected']);

  const { t } = useI18n();
  const loadingStore = useLoadingStore();
  const toaster = createToaster({ position: 'top-right' });
  const datosFiscales = ref([]);
  const selectedDatosFiscalesId = ref(null);
  const tempSelectedDatosFiscalesId = ref(null);
  const showModalFormulario = ref(false);
  const showModalSeleccion = ref(false);
  const formularioRef = ref(null);
  const datosFiscalesEdit = ref(null);
  const isEditMode = ref(false);

  const checkins = computed(() => {
    return props.formularios.map(formulario => {
      if (!formulario || !formulario.checkIn) return {};

      const checkIn = formulario.checkIn;

      return {
        nombre: checkIn.nombre || '',
        apellidos: checkIn.apellidos || '',
        direccion: checkIn.direccion || '',
        codigoPostal: checkIn.codigoPostal || '',
        pais: checkIn.pais || '',
        dni: checkIn.dni || '',
        poblacion: checkIn.localidad || checkIn.poblacion || '',
        provincia: checkIn.provincia || '',
      };
    });
  });

  const hasDatosFiscales = computed(() => datosFiscales.value.length > 0);

  const selectedDatosFiscales = computed(() => {
    if (selectedDatosFiscalesId.value) {
      return datosFiscales.value.find(df => df.id === selectedDatosFiscalesId.value);
    }
    return null;
  });

  function emitDatosFiscalesId() {
    emit('datos-fiscales-selected', selectedDatosFiscalesId.value);
  }

  async function loadDatosFiscales() {
    try {
      loadingStore.show();
      const res = await UsuarioApiService.obtenerDatosUsuario();
      if (res.datosFiscales && res.datosFiscales.length > 0) {
        datosFiscales.value = res.datosFiscales;
        selectedDatosFiscalesId.value = res.datosFiscales[res.datosFiscales.length - 1].id;
      } else {
        datosFiscales.value = [];
        selectedDatosFiscalesId.value = null;
      }
    } catch (error) {
      console.error(error);
      datosFiscales.value = [];
      selectedDatosFiscalesId.value = null;
    } finally {
      loadingStore.hide();
    }
  }

  function selectDatosFiscales(index) {
    tempSelectedDatosFiscalesId.value = datosFiscales.value[index].id;
  }

  function openModalSeleccion() {
    tempSelectedDatosFiscalesId.value = selectedDatosFiscalesId.value;
    showModalSeleccion.value = true;
  }

  function closeModalSeleccion() {
    showModalSeleccion.value = false;
  }

  function handleGuardarSeleccion() {
    if (!tempSelectedDatosFiscalesId.value) {
      toaster.error(t('reserva.checkIn.error.seleccionaDatosFiscales'));
      return;
    }
    selectedDatosFiscalesId.value = tempSelectedDatosFiscalesId.value;
    closeModalSeleccion();
    emitDatosFiscalesId();
  }

  function openModalFormulario(datosFiscal = null) {
    isEditMode.value = !!datosFiscal;
    datosFiscalesEdit.value = datosFiscal;
    showModalFormulario.value = true;
    showModalSeleccion.value = false;
    if (!datosFiscal && formularioRef.value) {
      formularioRef.value.resetForm();
    }
  }

  function closeModalFormulario() {
    showModalFormulario.value = false;
    isEditMode.value = false;
    datosFiscalesEdit.value = null;
    if (formularioRef.value) {
      formularioRef.value.resetForm();
    }
  }

  async function handleSubmitFormulario() {
    if (!formularioRef.value || !formularioRef.value.isFormValid) {
      toaster.error(t('reserva.checkIn.error.formularioIncompleto'));
      return;
    }

    try {
      loadingStore.show();
      const datosFiscalesDTO = { ...formularioRef.value.formularioData };

      if (isEditMode.value && datosFiscalesEdit.value?.id) {
        datosFiscalesDTO.id = datosFiscalesEdit.value.id;
      }

      if (
        formularioRef.value.formularioData.tipo === TIPO_DATOS_FISCALES.EMPRESA ||
        formularioRef.value.formularioData.tipo === TIPO_DATOS_FISCALES.AUTONOMO
      ) {
        delete datosFiscalesDTO.nombre;
        delete datosFiscalesDTO.apellidos;
      }
      if (formularioRef.value.formularioData.tipo === TIPO_DATOS_FISCALES.PARTICULAR) {
        delete datosFiscalesDTO.razonSocial;
      }

      const response = await UsuarioApiService.modificarDatosFiscales(datosFiscalesDTO);
      toaster.success(t('reserva.datosFiscales.datosGuardados'));
      await loadDatosFiscales();

      if (response.id) {
        tempSelectedDatosFiscalesId.value = response.id;
      }
      closeModalFormulario();
      showModalSeleccion.value = true;
      emitDatosFiscalesId();
    } catch (error) {
      console.error(error);
      toaster.error(t('errors.inesperado'));
    } finally {
      loadingStore.hide();
    }
  }

  async function submit() {
    if (hasDatosFiscales.value) {
      if (!selectedDatosFiscalesId.value) {
        toaster.error(t('reserva.checkIn.error.seleccionaDatosFiscales'));
        return false;
      }
      return true;
    } else {
      if (!formularioRef.value || !formularioRef.value.isFormValid) {
        toaster.error(t('reserva.checkIn.error.formularioIncompleto'));
        return false;
      }
      try {
        loadingStore.show();
        const datosFiscalesDTO = { ...formularioRef.value.formularioData };

        if (
          formularioRef.value.formularioData.tipo === TIPO_DATOS_FISCALES.EMPRESA ||
          formularioRef.value.formularioData.tipo === TIPO_DATOS_FISCALES.AUTONOMO
        ) {
          delete datosFiscalesDTO.nombre;
          delete datosFiscalesDTO.apellidos;
        }
        if (formularioRef.value.formularioData.tipo === TIPO_DATOS_FISCALES.PARTICULAR) {
          delete datosFiscalesDTO.razonSocial;
        }

        const response = await UsuarioApiService.modificarDatosFiscales(datosFiscalesDTO);
        await loadDatosFiscales();
        if (response.id) {
          selectedDatosFiscalesId.value = response.id;
        }
        emitDatosFiscalesId();
        return true;
      } catch (error) {
        console.error(error);
        toaster.error(t('errors.inesperado'));
        return false;
      } finally {
        loadingStore.hide();
      }
    }
  }

  onBeforeMount(async () => {
    await loadDatosFiscales();
    emitDatosFiscalesId();
  });

  defineExpose({
    submit,
  });
</script>

<style scoped lang="scss">
  .card-resumen {
    border-radius: var(--bs-border-radius-xl) !important;
    border: 1px solid rgba(var(--bs-primary-rgb), 0.25);

    .card-body {
      padding: 20px;
    }

    .title {
      font-size: 19px;
      font-weight: 600;
    }

    .btn-cambiar {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;

      &:hover {
        opacity: 0.8;
      }
    }

    .datos-fiscales-preview {
      .datos-fiscales-container {
        .check-container {
          margin-right: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          pointer-events: none;
          user-select: none;
          flex-shrink: 0;

          i {
            font-size: 16px;
          }
        }

        .datos-container {
          flex: 1;
        }
      }
    }

    .datos-fiscales-item {
      padding: 12px;
      border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
      border-radius: var(--bs-border-radius);
      transition: all 0.2s ease;

      &:hover {
        border-color: rgba(var(--bs-primary-rgb), 0.4);
        background-color: rgba(var(--bs-primary-rgb), 0.02);
      }

      .form-check-input {
        margin-top: 0.25rem;
        cursor: pointer;
      }

      .form-check-label {
        cursor: pointer;
      }
    }
  }

  // Estilos para el modal de selección de datos fiscales
  .datos-fiscales-item-modal {
    padding: 20px;
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    border-radius: var(--bs-border-radius-xl);
    position: relative;

    .btn-edit-modal {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 1px solid rgba(var(--bs-primary-rgb), 0.4);
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 0;
      z-index: 1;

      &:hover {
        opacity: 0.8;
      }
    }

    .datos-fiscales-container-modal {
      .check-container-modal {
        margin-right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        cursor: pointer;

        i {
          font-size: 16px;
        }
      }

      .datos-container-modal {
        flex: 1;
        cursor: pointer;
      }
    }
  }

  .btn-nuevo-formulario {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    color: var(--bs-primary);

    &:hover {
      opacity: 0.8;
    }
  }

  @media screen and (max-width: 678px) {
    .card-resumen {
      .card-body {
        border-radius: var(--bs-border-radius-xl);
      }

      label,
      p {
        font-size: 0.8rem;
      }
    }
  }

  .collapse-enter-active,
  .collapse-leave-active {
    transition: all 0.15s ease;
  }

  .collapse-enter-from,
  .collapse-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }

  .form-check-input[type='radio'] {
    cursor: pointer;
    border: 1px solid rgba(var(--bs-primary-rgb), 0.3);

    &:checked {
      background-color: var(--bs-secondary);
      border-color: var(--bs-primary);
    }

    &:focus {
      box-shadow: none;
    }
  }

  .form-check-input[type='checkbox'] {
    &:checked {
      background-color: var(--bs-primary);
      border-color: var(--bs-primary);
    }
  }

  :deep(.modal-footer) {
    .btn-link {
      height: 40px;
      border-radius: var(--bs-border-radius-xxl);
      border: 1px solid var(--bs-primary) !important;
      padding: 0 16px;
      transition: 0.2s;
      background-color: transparent;
      color: var(--bs-primary);
      box-shadow: none !important;
      text-decoration: none;
      font-size: 16px;
      font-weight: 500;
      margin-right: 20px;

      &:hover {
        background-color: rgba(var(--bs-primary-rgb), 0.2);
        box-shadow: none !important;
      }

      &:focus {
        box-shadow: none !important;
      }

      &:active {
        box-shadow: none !important;
      }
    }

    .btn-primary {
      height: 40px;
      border-radius: var(--bs-border-radius-xxl);
      border: none !important;
      padding: 0 16px;
      transition: 0.2s;
      background-color: var(--bs-secondary);
      color: var(--bs-primary);
      box-shadow: none !important;
      font-size: 16px;
      font-weight: 500;

      &:hover {
        opacity: 0.75;
        box-shadow: none !important;
      }

      &:focus {
        box-shadow: none !important;
      }

      &:active {
        box-shadow: none !important;
      }
    }
  }
</style>
